import React, { useState } from 'react';
import {
  ArrowLeft,
  Globe,
  Check,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { cn } from '../../lib/utils';

const LANGUAGES = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'zh', name: 'Chinese', native: '中文' },
  { code: 'ja', name: 'Japanese', native: '日本語' },
  { code: 'ko', name: 'Korean', native: '한국어' },
  { code: 'pt', name: 'Portuguese', native: 'Português' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'it', name: 'Italian', native: 'Italiano' },
  { code: 'ar', name: 'Arabic', native: 'العربية' },
];

export function LanguagePage() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(() => localStorage.getItem('fash-language') || 'en');

  const handleSelect = (code: string) => {
    setSelected(code);
    localStorage.setItem('fash-language', code);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="sticky top-0 z-40 bg-white border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <div className="flex items-center">
            <button onClick={() => navigate('/settings')} className="p-2 -ml-2 hover:bg-gray-100 rounded-full transition-colors">
              <ArrowLeft className="h-6 w-6 text-heading" />
            </button>
            <h1 className="ml-4 text-xl font-serif text-heading">Language</h1>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6 space-y-4 pb-24">
        <p className="text-sm text-body px-1">
          Choose your preferred language. Currently, the app is available in English with more languages coming soon.
        </p>

        <Card>
          <CardContent className="p-0 divide-y divide-gray-100">
            {LANGUAGES.map(lang => (
              <button
                key={lang.code}
                onClick={() => handleSelect(lang.code)}
                className={cn(
                  'w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors text-left',
                  selected === lang.code && 'bg-primary/5'
                )}
              >
                <div>
                  <p className="font-medium text-heading">{lang.name}</p>
                  <p className="text-sm text-body">{lang.native}</p>
                </div>
                <div className="flex items-center space-x-2">
                  {lang.code !== 'en' && (
                    <span className="text-xs text-body bg-gray-100 px-2 py-0.5 rounded-full">Coming soon</span>
                  )}
                  {selected === lang.code && (
                    <Check className="h-5 w-5 text-primary" />
                  )}
                </div>
              </button>
            ))}
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
